import React from 'react'
import Liberyus from '../../components/general/liberyus'
import HardwareBanner from './hardware-banner'
import Hardwares from './hardwares'
import { useNavigate } from 'react-router-dom'

const HardwarePage = () => {
    const navigation = useNavigate()

    return (
        <Liberyus>
            <div className='hardware-page'>
                <HardwareBanner />
                <Hardwares />
                <div className='hardware-contact'>
                    <div>
                        <div className='text'><span>Looking to enhance your IT infrastructure, boost cybersecurity, or streamline operations with cutting-edge automation solutions? Get in touch with us today!</span></div>
                        <div className='w-100 d-flex justify-content-center text-center'>
                            <div className='hardware-contact-btn text-center' onClick={() => navigation('/contact')}>
                                <span>Contact Us</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Liberyus>
    )
}

export default HardwarePage
